import { get, post, put } from '@/infrastructure/http-client/axios';

export const apiGetDataUser = async (userCode) =>
  await get(`/attention-queues/v1/catalogueAttention/getDataUser/${userCode}`);

export const apiGetCustomerBooking = async (payload) =>
  await post(`/attention-queues/v1/bookings/getCustomerBooking`, payload);

export const apiUpdateBooking = async (payload) =>
  await put(`/attention-queues/v1/bookings/save`, payload);

export const apiGetReasonList = async () =>
  await get(`/attention-queues/v1/bookings/reasonsList`);

export const apiGetAttentionQueueList = async (attentionType) =>
  await get(
    `/attention-queues/v1/catalogueAttention/attentionQueueList/${attentionType}`
  );

export const apiGetPriorityList = async () =>
  await get(`/attention-queues/v1/catalogueAttention/priorityList`);

export const apiGetBoxesList = async (payload) =>
  await post(`/attention-queues/v1/catalogueAttention/boxList`, payload);

export const apiGenerateTicket = async (payload) =>
  await post(`/attention-queues/v1/attentionTicket/save`, payload);

export const apiGetHeadquartersList = async () =>
  await get('/attention-queues/v1/bookings/headquartersList');

export const apiRegisterBox = async (payload) =>
  await post('/attention-queues/v1/attentionTicket/registerBox', payload);
export const apiUpdateTicket = async (payload) =>
  await put(`/attention-queues/v1/attentionTicket/save`, payload);

export const apiGetTypifitacionList = async () =>
  await get(`/attention-queues/v1/catalogueAttention/typifitacionList`);

export const apiGetAppointmentList = async (attentionType) =>
  await get(`/attention-queues/v1/bookings/list/${attentionType}`);

export const apiValidateNonClient = async (document) =>
  await get(`/attention-queues/v1/client/validate/${document}`);

export const apiRegiterNonClient = async (payload) =>
  await post('/attention-queues/v1/client/register', payload);
